import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, ListGroupItem, Panel } from 'react-bootstrap';
import ActivityGroup from './ActivityGroup.jsx';

const GroupByCodeTreeItem = ({ codeItem, filteredActivities, filteredActivitiesMap, datasetInfo }) => {
	const { name, children, childrenSequence, activityIds = [], descendantActivityCount } = codeItem;

	if (!descendantActivityCount) {
		return null;
	}

	let codeTree = [];
	if (childrenSequence.length) {
		for (let i = 0; i < childrenSequence.length; i++) {
			const childGroupId = childrenSequence[i];
			const codeItem = children[childGroupId];
			codeTree.push(
				<ListGroupItem key={childGroupId}>
					<GroupByCodeTreeItem
						codeItem={codeItem}
						filteredActivities={filteredActivities}
						filteredActivitiesMap={filteredActivitiesMap}
						datasetInfo={datasetInfo} />
				</ListGroupItem>
			);
		}
		codeTree = <ListGroup className="groupTreeListGroup">{codeTree}</ListGroup>;
	} else {
		codeTree = null;
	}

	const activitiesForActivityCode = activityIds.map(activityId => {
		return filteredActivities[filteredActivitiesMap[activityId]];
	});

	const activityGroup = (
		<ActivityGroup
			className="activityListPanel"
			activities={activitiesForActivityCode}
			datasetInfo={datasetInfo} />
	);

	return (
		<Panel
			defaultExpanded
			className="groupTreePanel">
			<Panel.Heading>
				<Panel.Title toggle>{`${name} (${descendantActivityCount})`}</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				{activityGroup}
				{codeTree}
			</Panel.Collapse>
		</Panel>
	);
};

GroupByCodeTreeItem.propTypes = {
	codeItem: PropTypes.shape({
		activityIds: PropTypes.array,
		name: PropTypes.string,
		childrenSequence: PropTypes.shape({
			length: PropTypes.string
		}),
		children: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.array
		]),
		descendantActivityCount: PropTypes.number
	}),
	filteredActivities: PropTypes.array,
	filteredActivitiesMap: PropTypes.object,
	datasetInfo: PropTypes.object
};

export default GroupByCodeTreeItem;